export const PostAdBegin = 'PostAdBegin'

export const PostAdFreeSuccess = 'PostAdFreeSuccess'
export const PostAdPaidSuccess = 'PostAdPaidSuccess'
export const EditAdFreeSuccess = 'EditAdFreeSuccess'
export const EditAdPaidSuccess = 'EditAdPaidSuccess'
